import React from 'react'

type Props = React.SVGAttributes<SVGSVGElement>

export const RedFlag: React.FC<Props> = props => {
  return (
    <svg width={118} height={136} viewBox="0 0 118 136" fill="none" {...props}>
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          d="M21.851 17.553s10.189 2.55 18.453 3.039c8.265.489 33.428-3.652 47.94-3.039 11.533.488 18.65 3.987 21.085 5.403.624.363 1.028.975 1.175 1.682 1.072 5.144 5.567 27.284 6.321 40.22.46 7.884.787 14.914.991 19.74.066 1.558-3.916 3.76-5.345 3.135-1.63-.711-3.723-1.501-6.408-2.343-10.761-3.377-44.266 2.062-49.439 2.538-5.172.477-19.543.445-22.069-2.538-2.526-2.983 1.542-2.998.507-8.289-1.036-5.29-13.21-59.548-13.21-59.548z"
          fill="#F53D46"
        />
        <path
          d="M71.579 67.616a3.063 3.063 0 01-3.392-2.698l-.063-.552a3.07 3.07 0 012.701-3.395 3.063 3.063 0 013.392 2.698l.063.552a3.07 3.07 0 01-2.701 3.395zm-1.51-13.271a3.063 3.063 0 01-3.392-2.698l-1.57-13.843a3.07 3.07 0 012.7-3.396 3.063 3.063 0 013.393 2.698l1.57 13.843a3.07 3.07 0 01-2.701 3.396z"
          fill="#fff"
        />
        <path
          d="M19.993 18.82s3.76 7.397 5.847 15.215c2.087 7.818 15.794 40.021 15.794 41.868 0 1.846-1.412 1.317-3.891 2.875-2.48 1.557-3.29 3.082-3.29 3.082s.816-2.188.604-4.751c-.213-2.564-15.064-58.29-15.064-58.29z"
          fill="#994246"
        />
        <path
          d="M2.68 10.13s21.407-5.294 24.828-2.647c3.421 2.648-5.007 12.848 2.06 31.43 7.067 18.583 14.5 34.418 11.75 38.199 0 0 0-1.774-3.235-3.203-3.235-1.43-26.094 3.203-26.094 3.203L2.679 10.13z"
          fill="#E03740"
        />
        <path
          d="M.359 3.243A2.635 2.635 0 012.676.324a2.629 2.629 0 012.912 2.312l14.973 130.12a2.635 2.635 0 01-2.317 2.919 2.629 2.629 0 01-2.913-2.312L.36 3.243z"
          fill="#E2E8EB"
        />
        <path
          d="M.307 3.31a2.71 2.71 0 012.2-2.973s-.775 1.235-.56 3.452C2.16 6.006 15.942 127.924 16.36 131.39c.417 3.466 1.479 3.862 1.479 3.862a2.562 2.562 0 01-2.712-2.266L.307 3.31z"
          fill="#D8DEE0"
        />
      </g>
    </svg>
  )
}
